<template>
  <div class="d-flex total_manager" id="wrapper">
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'NoneLayout',
}
</script>
